<app-content-page-layout title="Discover Recipes"
  ><!-- Create recipe button -->
  <div pageActions class="">
    <button
      (click)="createRecipe()"
      class="flex gap-2 px-4 py-2 bg-blue-700 hover:bg-blue-800 text-white text-sm font-semibold rounded-lg transition"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-5 h-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
      </svg>
      Create
    </button>
  </div>
  <div
    class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4"
  >
    @for (recipe of recipes; track recipes.indexOf(recipe)) {
      <div
        class="max-w-full bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700"
      >
        <a [href]="'/app/recipe?id=' + recipe.id">
          <img
            class="rounded-t-lg max-h-[25vh] w-full object-cover"
            src="{{ recipe.image_url }}"
            alt=""
          />
        </a>
        <div class="p-3">
          <a [href]="'/app/recipe?id=' + recipe.id">
            <h5 class="mb-2 text-xl font-semibold tracking-tight text-gray-900 dark:text-white">
              {{ recipe.name }}
            </h5>
          </a>
          @let combined =
            [...culinaryService.getDietsAsStrings(recipe), ...recipe.tags.map(t => t.name)];
          <div class="flex flex-wrap w-full items-center gap-2 pt-3">
            @for (badge of combined.slice(0, 4); track $index) {
              <app-badge [text]="badge" />
            }
            @if (combined.length > 4) {
              <app-badge [text]="`+${combined.length - 4} more`" />
              <span class="text-sm text-gray-500 font-medium"> </span>
            }
          </div>
        </div>
      </div>
    }
  </div>
</app-content-page-layout>
